import { render } from "./G.vue?vue&type=template&id=2e191f21"
import script from "./G.vue?vue&type=script&lang=js"
export * from "./G.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__